<template>
  <div id="page">
          <div class="wrap">
            <div class="left-wrap">
              <section class="jobs">
                <div class="search-wrap">
                  <div class="wrap">
                      <div class="form-div">
                        <van-search
                          v-model="searchContent"
                          show-action
                          label="职位"
                          placeholder="请输入搜索关键词"
                          @search="selectChange()"
                        >
                          <template #action>
                            <div @click="selectChange()" style="background-color:rgb(178,16,16)">搜索</div>
                          </template>
                        </van-search>
                      </div>
                    <!-- <van-field right-icon="arrow" input-align="right" name="apply_post" readonly clickable label="职位类型"
                    :value="place" placeholder="请选择" @click="apply_postPicker = true"
                    :rules="[{ required: true }]"></van-field>
                    <van-field right-icon="arrow" input-align="right" name="apply_post" readonly clickable label="城市"
                    :value="place" placeholder="请选择" @click="apply_postPicker = true"
                    :rules="[{ required: true }]"></van-field> -->
                  </div>
              </div>

              </section>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
                @load="onLoad()"
                class="list"
              >
                  <div class="item" v-for="(item , index) in list" :key="index" @click="todetail(item.id)">
                    <div class="content-hd">
                      <h4><span v-show="item.hot" class="ji">急</span>{{item.workName}}</h4>
                      <p class="color-on">{{item.salary}}</p>
                    </div>
                    <div class="content-bd">
                      <p>{{item.dept.deptName}}</p>
                      <p class="area">{{item.province}}</p>
                    </div>
                  </div>
              </van-list>
            </div>
          </div>
        <van-popup v-model="apply_postPicker" round position="bottom">
            <van-picker show-toolbar :columns="columns" @cancel="apply_postPicker = false"
                @confirm="apply_postOK" />
        </van-popup>
  </div>
</template>

<script>

export default {
  name:"jobslist",
  data(){
    return{
      searchContent:'',
      place:'',
      deptId:'',
      columns: [{
          text: "福州",
      },{
          text: "厦门",
      }],
      apply_postPicker:false,
      typeArr:[],
      list:[],
      load:1,
      type:1,
      curr_page:1,
      loading: false,
      finished: false,
      error:false,
    }
  },
  created(){
    let arr = location.href.split("/");
    this.type = arr[arr.length - 1];
    //获取职位列表
    // this.getList();
    // //获取职位类别信息
    // axios.get("/getDept").then(function(res) {
    //   vm.typeArr = res.data.jobsType;
    // }).catch(error => {
    //   console.log(error);
    // })
  },
  mounted(){
    this.getList();
  },
  methods:{
    getList(){//获取职位列表
    let that = this;
      this.$ajax.get("/brief/" + this.type, {
        params: {
          page: this.curr_page
        }
      }).then(function(res){
        console.log(res);
        let list = res.jobs.data;
        if( list.length < 1  ){
          that.finished = true;
          return;
        }

        for (let i in list) {  //list为获取的数据列表
          that.list.push(list[i]);  //追加在已有数据后
        }
        if( list.length < 10  ){
          that.finished = true;
            return;
          }
      }).catch(error => {
        that.error = true;
      });
    },
    todetail(id) {
      this.$router.push(`/jobsdetail/${id}`);
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.curr_page += 1;
        this.getList();
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
      }, 1000);
    },
    apply_postOK(value) {
      this.place = value;
      this.apply_postPicker = false
    },
    selectChange(){
      let that = this;
      let data = { "content":this.searchContent,'province':this.place,'id':this.type,"dept":this.deptId }
      this.$ajax.post("/jobSelect/",data).then(function(res) {
        that.list = res.jobs.data;
      }).catch(error => {
        console.log(error);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 内容容器
.van-search__action{
    background: rgb(178,16,16);
    color: #fff;
}
.van-search{
  padding: 10px 0;
  width: 85%;
}
.wrap{
  margin-top: 5rem;
}
input {
  &:focus{
    border-color:rgba(178,16,16,0.3) !important;
  }
}
.el-select-dropdown__item.selected{
  color: rgb(178,16,16) !important;
  font-weight: 200;
}

.jobs{
  .search-wrap{
    background-color: #fff;
    padding: 0px 10px;
    .hd-wrap{
      padding: 10px 0;
    }
    .form-div{
      margin: 20px 0;
      display: flex;
      justify-content: center;
    }
  }
}
.ji{
  padding: .2rem .3rem;
  background-color: #FF6B6B;
  text-align: center;
  color: #fff;
  margin-right: .3rem;
  font-size: .8rem !important;
}
.on{
  width: .5rem;
  height: .5rem;
  margin-right: 5px;
}

.list{
  >.item{
    padding: 1rem;
    cursor: pointer;
    border-bottom: 2px solid rgb(245,245,245);
    p{
      color: #999;
      line-height: 30px;
    }
    >.content-hd{
      display: flex;
      justify-content: space-between;
      >h4{
        font-size: 1.2rem;
        line-height: 1.3em;
      }
      .color-on{
        margin-left: 2%;
        color: #FF6B6B;
        font-size: 1.2rem;
      }

    }
    >.content-bd{
      display: flex;
      justify-content: flex-start;
      .area{
        margin-left: .5rem;
      }

    }
    >.content-ft{
      display: flex;
      justify-content: space-between;
      p{
        &:last-child{
          font-size: 12px;
        }
      }
    }
  }
}

.loading {
  display: flex;
  justify-content: center;
  p {
    font-size: px2rem(14);
    color: #999;
    text-align: center;
    &.retry {
      span {
        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
        &:active {
          color: #666;
        }
      }
    }
    &.load-icon {
      img {
        position: relative;
        width: 30px;
        height: 30px;
        animation: rotate 1.6s linear infinite;
        margin: 0 auto;
        // padding-top: 50px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/jobs.vue